export default class addressDataClass
{
    id = null;

    type = 'Home';

    line_1 = null;

    line_2 = null;

    line_3 = null;

    area = null;

    city = null;

    state = null;

    pincode = null;

    country = null;

    slug = null;

    pivot = { private: false };

    members = [];
}